/**
 * function setFormDataKey 设置所需要验证的对象的 key，不调用则默认data中的key
 * 设置了 key，验证 this.[{key}].{field}；未设置 key，验证 this.{field}
 *
 * tel 验证手机，常规正则验证
 * mail 验证邮箱，常规正则验证
 * rpwd 二次密码验证，与第一次输入比较
 * pwd 密码验证，自定义正则验证
 * code 仅做位数验证
 * isNull 字段 非空验证，包含 对象，字符串，数组
 */
export const validate = {
  data() {
    return {
      validate: {
        timeOut: null,
        // 正则校验错误集合
        reg_verify_err: {},
        // 正则校验错误信息集合
        reg_verify_err_msg: {},
        formDataKey: "",
        // 手机号正则验证
        tel: (key) => {
          let val = this[key];
          if (this.validate.formDataKey) {
            val = this[this.validate.formDataKey][key];
          }
          const res = val.length == 11;
          if (!res) {
            this.validate.reg_verify_err_msg[key] = `请输入正确的手机号`;
            this.$toast.fail("请输入正确的手机号");
          } else {
            this.validate.reg_verify_err_msg[key] = "";
          }
          this.validate.reg_verify_err[key] = !res;
          this.$forceUpdate();
          return res;
        },
        // 邮箱正则验证
        mail: (key) => {
          return true;
        },
        // 密码二次验证
        rpwd: (k1 = "pwd", k2 = "rpwd") => {
          let val = this[k1];
          let val2 = this[k2];
          if (this.validate.formDataKey) {
            val = this[this.validate.formDataKey][k1];
            val2 = this[this.validate.formDataKey][k2];
          }
          const res = val === val2;
          this.validate.reg_verify_err_msg[k2] = res
            ? ""
            : "两次输入的密码不一致";
          this.validate.reg_verify_err[k2] = !res;

          if (!res) {
            this.$toast.fail(this.validate.reg_verify_err_msg[k2]);
          }
          this.$forceUpdate();
          return res;
        },
        // 手机验证码
        code: (key = "code") => {
          let val = this[key];
          if (this.validate.formDataKey) {
            val = this[this.validate.formDataKey][key];
          }
          const res = val.length === 6;
          this.validate.reg_verify_err_msg[key] = res
            ? ""
            : "验证码为长度为6的纯数字";
          this.validate.reg_verify_err[key] = !res;

          if (!res) {
            this.$toast.fail(this.validate.reg_verify_err_msg[key]);
          }
          this.$forceUpdate();
          return res;
        },
        // 密码正则验证
        pwd: (key = "pwd") => {
          let val = this[key];
          if (this.validate.formDataKey) {
            val = this[this.validate.formDataKey][key];
          }
          const RegPassStr = /^[\da-zA-Z~@.]*$/;
          const res = new RegExp(RegPassStr).test(val);
          if (!res || val.length < 6 || val.length > 16) {
            this.validate.reg_verify_err_msg[
              key
            ] = `6~16位字母、数字组合（特殊字符支持.@~）`;
            this.$toast.fail(this.validate.reg_verify_err_msg[key]);
            this.validate.reg_verify_err[key] = true;
          } else {
            this.validate.reg_verify_err_msg[key] = "";
            this.validate.reg_verify_err[key] = false;
          }
          this.$forceUpdate();
          return res;
        },
        // 字段为空验证
        isNull: (key) => {
          let val = this[key];
          if (this.validate.formDataKey) {
            val = this[this.validate.formDataKey][key];
          }
          let pass;
          pass =
            val !== null &&
            val !== "" &&
            val !== undefined &&
            JSON.stringify(val) !== "{}";
          if (Array.isArray(val)) {
            pass = val.length > 0;
          }
          if('schoolName' == key){
            return true
          }
          if('mail' == key){
            return true
          }
          if (!pass) this.validate.fieldMsg[key] = "该字段不可为空";
          else this.validate.fieldMsg[key] = "";
          this.validate.fieldErr[key] = !pass;
          return pass;
        },
        // 为空验证返回错误信息集合
        fieldMsg: {},
        fieldErr: {},
        // 清空错误信息
        errMsgEmpty: () => {
          if (this.validate.timeOut) window.clearTimeout(this.validate.timeOut);
          this.validate.timeOut = window.setTimeout(() => {
            for (let k in this.validate.fieldMsg) {
              this.validate.fieldMsg[k] = "";
              this.validate.fieldErr[k] = false;
            }
            for (let k in this.validate.reg_verify_err) {
              this.validate.reg_verify_err[k] = false;
            }
            for (let k in this.validate.reg_verify_err_msg) {
              this.validate.reg_verify_err_msg[k] = "";
            }
            this.$forceUpdate();
          }, 3000);
        },
        // 弹出错误信息
        errMsgPopup: () => {
          for (let k in this.validate.reg_verify_err_msg) {
            let val = this.validate.reg_verify_err_msg[k];
            if (val) {
              this.$root.$toast.fail(val);
            }
          }
        },
        // 非必填手机正则验证
        unMustPhoneCheck: (key) => {
          let val = this[key];
          if (this.validate.formDataKey) {
            val = this[this.validate.formDataKey][key];
          }

          const reg =
            /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/;
          const res = new RegExp(reg).test(val) || val === "";
          if (!res) {
            this.validate.fieldMsg[key] = "手机号格式不正确";
            this.$toast.fail(this.validate.fieldMsg[key]);
          } else this.validate.fieldMsg[key] = "";
          this.validate.fieldErr[key] = !res;
          return res;
        },
        // 非必填身份证正则验证
        unMustidcardCheck: (key) => {
          let val = this[key];
          if (this.validate.formDataKey) {
            val = this[this.validate.formDataKey][key];
          }

          const reg =
            /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          const reg1 =
            /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
          const res =
            new RegExp(reg).test(val) ||
            new RegExp(reg1).test(val) ||
            val === "";
          if (!res) {
            this.validate.fieldMsg[key] = "身份证格式不正确";
            this.$toast.fail(this.validate.fieldMsg[key]);
          } else this.validate.fieldMsg[key] = "";
          this.validate.fieldErr[key] = !res;
          return res;
        },
        // 设置需要验证对象的key
        setFormDataKey: (name) => {
          this.validate.formDataKey = name;
        }
      }
    };
  },
  mounted() {
    // eslint-disable-next-line
    this.verification = new Verification.Init();
  }
};
